import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function PlatformAdmin() {
  const [analytics, setAnalytics] = useState({});
  const [leads, setLeads] = useState([]);
  useEffect(() => { (async () => {
    const [a, l] = await Promise.all([api.get("/platform/analytics"), api.get("/leads")]);
    setAnalytics(a.data); setLeads(l.data.leads || []);
  })(); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="label-mono mb-2">Platform Analytics</div>
        <h1 className="font-display text-4xl font-bold tracking-tight text-slate-950">ATLAS™ Platform</h1>
        <p className="mt-2 text-sm text-stone-600">System-wide metrics across every organization and entrepreneur.</p>
      </div>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {[
          ["Users", analytics.total_users || 0],
          ["Organizations", analytics.total_organizations || 0],
          ["Entrepreneurs", analytics.total_entrepreneurs || 0],
          ["Assets", analytics.total_assets || 0],
          ["Health Scores", analytics.total_health_scores || 0],
          ["Chats", analytics.total_chats || 0],
          ["Leads", analytics.total_leads || 0],
          ["Competitions", analytics.total_competitions || 0],
        ].map(([l, v]) => (
          <div key={l} className="card-flat">
            <div className="label-mono">{l}</div>
            <div className="kpi-num mt-2">{v}</div>
          </div>
        ))}
      </div>

      <div className="card-flat">
        <div className="label-mono mb-3">Demo / Discovery / Pricing Requests</div>
        <div className="overflow-x-auto rounded-md border border-stone-200">
          <table className="min-w-full text-sm">
            <thead className="bg-stone-50 text-left">
              <tr className="border-b border-stone-200">
                <th className="px-4 py-2 font-mono text-[10px] uppercase tracking-wider text-stone-500">Type</th>
                <th className="px-4 py-2 font-mono text-[10px] uppercase tracking-wider text-stone-500">Name</th>
                <th className="px-4 py-2 font-mono text-[10px] uppercase tracking-wider text-stone-500">Email</th>
                <th className="px-4 py-2 font-mono text-[10px] uppercase tracking-wider text-stone-500">Organization</th>
                <th className="px-4 py-2 font-mono text-[10px] uppercase tracking-wider text-stone-500">Size</th>
                <th className="px-4 py-2 font-mono text-[10px] uppercase tracking-wider text-stone-500">Received</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {leads.map((l) => (
                <tr key={l.id}>
                  <td className="px-4 py-3 font-mono text-xs uppercase text-emerald-700">{l.request_type}</td>
                  <td className="px-4 py-3 font-medium text-slate-950">{l.name}</td>
                  <td className="px-4 py-3 text-stone-600">{l.email}</td>
                  <td className="px-4 py-3 text-stone-600">{l.organization || "—"}</td>
                  <td className="px-4 py-3 text-stone-600">{l.org_size || "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs text-stone-500">{new Date(l.created_at).toLocaleString()}</td>
                </tr>
              ))}
              {leads.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-xs text-stone-500">No leads yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
